// AJAX cart with checkmark replacing the + sign and changing text
document.addEventListener('DOMContentLoaded', function() {
  // Select all ajax add-to-cart buttons
  const addToCartButtons = document.querySelectorAll('.ajax-add-to-cart');
  
  if (addToCartButtons.length > 0) {
    // Add event listeners to all buttons
    addToCartButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        
        const variantId = this.getAttribute('data-variant-id');
        // Store original text for later restoration
        const originalText = this.textContent.trim();
        
        // Change the button to "adding" status (without +)
        this.innerHTML = 'Adding';
        this.classList.add('is-adding');
        
        // Add the product to cart via fetch API
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        })
        .then(response => response.json())
        .then(data => {
          // Change the button to "added" status with checkmark replacing +
          button.innerHTML = '✓ Added';
          button.classList.remove('is-adding');
          button.classList.add('is-added');
          
          // Update the cart counter
          updateCartCount();
          
          // Reset the button after 2 seconds
          setTimeout(() => {
            button.innerHTML = originalText; // Restore original text with +
            button.classList.remove('is-added');
          }, 2000);
        })
        .catch(error => {
          console.error('Error:', error);
          // If something goes wrong, return button to original state
          button.innerHTML = originalText;
          button.classList.remove('is-adding');
        });
      });
    });
  }
  
  // Function to update cart count - with multiple selector support
  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Try different common selectors for cart count elements
        const cartCountSelectors = [
          '.cart-count',
          '.cart-count-bubble',
          '.cart-item-count',
          '.cart__count',
          '#CartCount',
          '.site-header__cart-count',
          '.header-cart-count',
          '[data-cart-count]',
          '.cart-count-number',
          '.header__cart-count'
        ];
        
        // Try each selector to find cart count elements
        let cartCountElements = [];
        for (const selector of cartCountSelectors) {
          const elements = document.querySelectorAll(selector);
          if (elements.length > 0) {
            cartCountElements = elements;
            break;
          }
        }
        
        // Update all found cart count elements
        if (cartCountElements.length > 0) {
          cartCountElements.forEach(element => {
            // Try to update the content based on common patterns
            if (element.querySelector('span')) {
              // If there's a span inside, update that
              element.querySelector('span').textContent = cart.item_count;
            } else {
              // Otherwise update the element directly
              element.textContent = cart.item_count;
            }
            
            // Add animation class
            element.classList.add('cart-count--updated');
            setTimeout(() => {
              element.classList.remove('cart-count--updated');
            }, 1000);
          });
        } else {
          console.log('Cart count element not found. Cart has', cart.item_count, 'items');
        }
      })
      .catch(error => console.error('Error fetching cart:', error));
  }
});